<template>
 <base-layout>
    <div style="height: 100%;">


        <div style="height: 100%" class="box-shadow">

        <!-- Layout for ESS Profile View -->

            <ob-layout :type="6">


                <!-- left section of the profile start-->
                <template slot="left-section">
                    <ob-spinner v-if="leftLoader" loading-text="Loading..."></ob-spinner>


                    <div v-else class="profile-info_details-wrapper">

                        <div class="profile-info_details" style="height:100%">
                            <div :class="{'profile_img_name':true}" style="display: flex; align-items: center;">
                                <!--'image_opacity':consultantDetails.VideoLink == null-->
                                <template>
                                    <img class="img-responsive" :src="profilePicture"  style="margin-left:5px;border-radius: 100%;  width: 60px;height: 60px;" />
                                </template>
                                <!--<img v-else class="img-responsive" :src="profilePicture" />-->

                                <label style="width: calc(100% - 80px);">
                                    <ob-popover  trigger="click" :options="{placement: 'bottom'}" ref="popover">
                                        <div class="popper">
                                            <div>
                                                <p class="pop-para"  @click="showWorkAuthHistory">View Work Auth History</p>
                                            </div>
                                        </div>
                                              <span v-if="empData.HireType == 'W2'" slot="reference" style="cursor:pointer;margin-right: 4px;" class="pull-right"><i class="fa fa-ellipsis-h" style="font-size: 20px;"></i></span>
                                    </ob-popover>
                                    <h3 class="profile-name-heading" v-if="empData.Name != '' && empData.Name != null" :title="empData.Name"> {{empData.Name}}</h3>
                                    <h3 class="profile-name-heading" v-else>N/A</h3>
                                    <span class="role designation-name" v-if="empData.Designation != '' && empData.Designation != null">{{empData.Designation}}</span>
                                    <span class="role designation-name" v-else>N/A</span>


                                </label>


                            </div>

                                <div class="contact-details col-md-12" style="padding: 10px 15px;">

                                    <div class="col-md-6 padding-0">
                                        <p v-if="empData.Email != '' && empData.Email != null" style="display: flex; align-items: center;"> <img style="margin-right: 2px;" :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/ess/ic_mail.svg`" />
                                          <a v-if="mailShow" href="#" @click="mailCopy"><span style="font-size:11px;"  :title="empData.Email" v-tooltip.top="'Click to copy the email address'">{{empData.Email.length > 20 ? empData.Email.substr(0, 15)+"..." : empData.Email}}</span></a>
                                          <a v-else><span style="font-size:11px;"  :title="empData.Email" v-tooltip.top="'Email address copied to clipboard'">{{empData.Email.length > 20 ? empData.Email.substr(0, 15)+"..." : empData.Email}}</span></a>
                                        </p>
                                        <p  v-else> <img style="margin-right: 2px;" :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/ess/ic_mail.svg`"/> N/A </p>
                                    </div>
                                    <div class="col-md-6" style="padding-right:0px;padding-left: 8px;">
                                        <p v-if="empData.Phone != '' && empData.Phone != null"> <img style="margin-right: 2px;" :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/ess/ic_phone.svg`" /> <span style="font-size:11px;" :title="empData.Phone">{{empData.Phone.length >= 13 ? empData.Phone.substr(0, 10)+"..." : empData.Phone }}</span> </p>
                                        <p v-else> <img style="margin-right: 2px;" :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/ess/ic_phone.svg`" /> N/A </p>
                                    </div>

                                </div>

                            <!-- Contact Details start-->

                            <!-- Contact Details fire-->


                            <!-- W2 Employee Info for HR -->
                                <div>
                                    <div class="col-md-12" style="margin-bottom: 10px;padding-top:10px; border-top:1px solid #ddd;width:103%;">
                                       <div class="col-md-6 padding-0">
                                            <p style="font-size: 11px;">Work Authorization Type</p>
                                            <p class="soc-datas" v-if="empData.WorkPermit != null && empData.WorkPermit != ''"> {{ empData.WorkPermit == 'EAD OTHERS' ? empData.Category != null && empData.Category != "" ? "EAD -" : "EAD" : empData.WorkPermit}} <span v-if="empData.IsCapGap == true && (empData.Category !=null  && empData.Category !='' &&((empData.WorkPermit == 'STEM OPT' && empData.Category =='C03C') || (empData.WorkPermit == 'OPT EAD' && empData.Category =='C03B')))" style="display:inline-block;margin-left:0px;color: red"> (CAP-GAP)</span><span v-if="(empData.WorkPermit == 'EAD OTHERS' || empData.WorkPermit == 'STEM OPT' || empData.WorkPermit == 'OPT EAD' || empData.WorkPermit=='Green Card') && empData.Category !=null  && empData.Category !='' && empData.IsCapGap == false" style="display:inline-block;margin-left:3px;"> {{empData.Category}}<span v-tooltip="empData.Description" style="margin-left: 3px;"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/info_blue_icon.svg`" style="width: 13px;margin-left: 3px;margin-bottom: 3px;"/></span></span></p>
                                            <p class="soc-datas" v-else>N/A</p>
                                            <p v-if="(empData.WorkPermit == 'EAD OTHERS' || empData.WorkPermit == 'STEM OPT' || empData.WorkPermit == 'OPT EAD') && empData.Category !=null  && empData.Category !='' && empData.IsCapGap == true" style="display:inline-block;margin-left:3px;"> {{empData.Category}}<span v-tooltip="empData.Description" style="margin-left: 3px;"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/info_blue_icon.svg`" style="width: 13px;margin-bottom: 3px;"/></span></p>
                                            <p v-if="empData.Is180DaysExt" style="color: #d80808;">180-day Extension</p>
                                        </div>
                                        <div class="col-md-6" style="padding-left: 8px;">
                                            <p style="font-size: 11px;"> {{ empData.WorkPermit }} Validity</p>
                                          <p class="soc-datas" v-if=" empData.WorkPermit != 'US Citizen' && empData.WorkAuthValidity != '' && empData.WorkAuthValidity != null"> {{ empData.WorkAuthValidity | formatDate('MM/DD/YYYY')}}</p>
                                            <p class="soc-datas" v-else>N/A</p>
                                        </div>
                                    </div>
                                    <div class="col-md-12" style="padding-bottom:10px;width:108%;">
                                        <div class="col-md-6 padding-0">
                                            <p style="font-size: 11px;" >Current Project Start Date</p>
                                            <!-- <span style="font-size: 11px;" v-else>Current Project Start Date</span> -->
                                            <p class="soc-datas" v-if="empData.CurrentProjectStartDate != '' && empData.CurrentProjectStartDate != null"> {{ empData.CurrentProjectStartDate| formatDate('MM/DD/YYYY')}}</p>
                                            <p class="soc-datas" v-else>N/A</p>
                                        </div>
                                        <div class="col-md-6 padding-right-0 pL0">
                                            <p style="font-size: 11px;" >Current Project End Date</p>
                                            <!-- <span style="font-size: 11px;" v-else>Current Project End Date</span> -->
                                            <p class="soc-datas" v-if="empData && (IsNullOrEmpty(empData.CurrentProjectEndDate) && !IsNullOrEmpty(empData.CurrentProjectStartDate)) ">No Expiration</p>
                                            <p class="soc-datas" v-else-if="empData.CurrentProjectEndDate  != '' && empData.CurrentProjectEndDate  != null">{{ empData.CurrentProjectEndDate | formatDate('MM/DD/YYYY') }}</p>
                                            <p class="soc-datas" v-else> N/A </p>
                                        </div>
                                    </div>
                                    <div class="col-md-12" style="padding-bottom:10px;">
                                        <div class="col-md-6 padding-0" v-if="empData.HireType == 'W2' ||empData.HireType == 'None'">
                                            <p style="font-size: 11px;">Employment/Contract Start Date</p>
                                            <p class="soc-datas" v-if="empData.EmpStartDate != '' && empData.EmpStartDate != null && empData.EmpStartDate != '0001/01/01T00:00:00'"> {{ empData.EmpStartDate | formatDate('MM/DD/YYYY') }}</p>
                                            <p class="soc-datas" v-else>N/A</p>
                                        </div>
                                        <div class="col-md-6 padding-0" v-else>
                                            <p style="font-size: 11px;">Employment/Contract Start Date</p>
                                            <p class="soc-datas" v-if="empData.ContractStartDate != '' && empData.ContractStartDate != null && empData.ContractStartDate != '0001/01/01T00:00:00'"> {{ empData.ContractStartDate | formatDate('MM/DD/YYYY') }}</p>
                                            <p class="soc-datas" v-else>N/A</p>
                                        </div>
                                         <div class="col-md-6">
                                            <p style="font-size: 11px;">Reporting Manager</p>
                                            <p class="soc-datas" v-if="empData.ReportingManager != '' && empData.ReportingManager != null"> {{empData.ReportingManager}}</p>
                                            <p class="soc-datas" v-else>N/A</p>
                                        </div>
                                    </div>
                                     <div class="col-md-12" style="padding-bottom:10px;">
                                        <div class="col-md-6 padding-0">
                                            <p style="font-size: 11px;">Client Name</p>
                                            <p class="soc-datas" v-if="empData.ClientName != '' && empData.ClientName != null"> {{ empData.ClientName }}</p>
                                            <p class="soc-datas" v-else>N/A</p>
                                        </div>
                                        <!-- <div class="col-md-6 padding-0">
                                            <p style="font-size: 11px;">Vendor Name</p>
                                            <p class="soc-datas" v-if="empData.VendorName != '' && empData.VendorName != null"> {{ empData.VendorName }}</p>
                                            <p class="soc-datas" v-else>N/A</p>
                                        </div> -->
                                        <div class="col-md-6 padding-right-0" style="padding-left: 12px;">
                                            <p style="font-size: 11px;">Client Contact</p>
                                            <p class="soc-datas" v-if="empData.ClientContactName != '' && empData.ClientContactName != null "> {{ empData.ClientContactName }}</p>
                                            <p class="soc-datas" v-else>N/A</p>
                                        </div>
                                    </div>
                                    <div class="col-md-12" style="padding-bottom:10px; border-bottom:1px solid #ddd;" v-if="empData.HireType != 'W2'">
                                        <div class="col-md-6 padding-0">
                                            <p style="font-size: 11px;">Vendor Name</p>
                                            <p class="soc-datas" v-if="empData.VendorName != '' && empData.VendorName != null"> {{ empData.VendorName }}</p>
                                            <p class="soc-datas" v-else>N/A</p>
                                        </div>
                                        <div class="col-md-6 padding-right-0" style="padding-left: 12px;">
                                            <p style="font-size: 11px;">Vendor Contact</p>
                                            <p class="soc-datas" v-if="empData.VendorContactName != '' && empData.VendorContactName != null "> {{ empData.VendorContactName }}</p>
                                            <p class="soc-datas" v-else>N/A</p>
                                        </div>
                                    </div>

                                </div>
                            <!-- Documents Alerts start-->
                            <div class="col-md-12" style="padding:0" >
                                <ob-collapse :expand="true">
                                    <h4 class="panel-title" slot="collapse-title">
                                        Document Alerts <span v-if="alertsLength != 0" class="alert-val"> {{alertsLength}} </span>
                                    </h4>

                                    <div slot="collapse-details">
                                        <div class="row collapase-details-holder">
                                            <template v-if="alertsLength > 0 && alertsData">
                                                <!--v-if="documentAlerts && documentAlerts.length > 0"-->
                                                <div  class="row document-alerts" v-for="(data,index) in alertsData" v-bind:key='index'>
                                                    <!-- v-for="(item, index) in documentAlerts" :key="index"-->
                                                    <!-- <div class="col-md-1" style="padding-right: 0;padding-left: 10px;">
                                                        <img src="/static/Css/Content/Images/vue/ess/ic__doc_alert.svg" class="document-alert-img" />
                                                        <img src="/Content/Images/vue/ess/ic_incomplete-docs.svg" v-else class="document-alert-img" />
                                                    </div> -->
                                                    <div class="col-md-1" style="padding-left:10px;padding-right:0px">
                                                      <img v-if="data.AlertType == 'Warning' " :src='`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/info-icon-orange.svg`'  class="document-alert-img">
                                                      <img v-else :src='`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/info_red_icon.svg`'  class="document-alert-img">
                                                    </div>
                                                    <div class="col-md-11" style="padding-left: 0px;">
                                                        <ul class="list-unstyled list-inline">
                                                            <li>
                                                                <ul class="list-unstyled">
                                                                    <li>
                                                                        <p class="document-alert-title"> {{getDescription(data.Description)}} </p>
                                                                        <div class="alert-time">
                                                                            <p> <i class="fa fa-clock-o" aria-hidden="true"></i> {{data.ModifiedDateTime | humantime}}</p>
                                                                        </div>
                                                                    </li>
                                                                </ul>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </template>
                                            <template v-else-if="complianceAlertsC2C != null && complianceAlertsC2C != ''">
                                                <div class="row document-alerts">
                                                    <div class="col-md-1" style="padding-right: 0">
                                                        <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/icons/info-icon-red.svg`" v-if="alertTypeC2C == 'Danger' " class="compliance-alert-img" />
                                                        <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/icons/warning.svg`" v-else class="compliance-alert-img" />
                                                    </div>
                                                    <div class="col-md-11" style="padding-left: 0px;">
                                                        <ul class="list-unstyled list-inline">
                                                            <li>
                                                                <ul class="list-unstyled">
                                                                    <li>
                                                                        <p class="compliance-alert-title">{{complianceAlertsC2C}}</p>
                                                                    </li>
                                                                </ul>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </template>
                                            <div v-else class="row m-0">
                                                <h3 class="text-center">No Alerts</h3>
                                            </div>
                                        </div>
                                    </div>
                                </ob-collapse>
                            </div>
                            <!-- Documents Alerts end-->
                        </div>

                    </div>


                </template>
                <!-- left section of the profile end-->
                <!--right section of the profile start-->

                <template slot="right-section">
                    <div class="profile-info_rightinfo">
                        <div class="profile-rightinfo_header">
                            <div class="header_tabs" :class="{'consultant_header_tabs': true}">
                                <ul>
                                    <li :class="{'active': $route.name == 'employee-details'}">
                                        <router-link :to="routeToEmployee" :class="{'router-link-exact-active router-link-active':$route.name == 'employee-details'}"><span>EMPLOYMENT DETAILS</span></router-link>
                                    </li>

                                     <li :class="{'active': $route.name == 'employee-projects'}">
                                        <router-link :to="routeToProject" :class="{'router-link-exact-active router-link-active':$route.name == 'employee-projects'}"><span>PROJECTS</span></router-link>
                                    </li>
                                    <li id="WORKAUTH"  :class="{'active': WorkAUTH}" @click="WorkAuthMethod">
                                        <a href="#">
                                            <span>Work Authorization  &nbsp;<i v-if="isMissingDocIconShow" class="fa fa-exclamation-circle" aria-hidden="true" style="color: red;"></i><i class="fa fa-chevron-down" aria-hidden="true" style="padding-left: 5px;cursor:pointer;"></i>

                                            </span></a>
                                    </li>
                                    <li id="FORMS" :class="{'active': Forms}" @click="FormsMethod">
                                        <a href="#">
                                            <span>FORMS &nbsp;<i class="fa fa-chevron-down" aria-hidden="true" style="padding-left: 5px;cursor:pointer;"></i>

                                            </span></a>
                                    </li>

                                    <li  :class="{'active': $route.name == 'employee-i9'}">
                                        <router-link :to="routeToI9"><span>FORM I-9</span></router-link>
                                    </li>
                                    <!-- <li v-if="isI983Visible && loggedInUserObj.HireType =='W2'" :class="{'active': $route.name == 'employee-form-i983'}">
                                        <router-link :to="routeToI983"><span>FORM I-983</span></router-link>
                                    </li> -->
                                    <li :class="{'active': $route.name == 'employee-resume'}">
                                        <router-link :to="routeToResume"><span>RESUME</span></router-link>
                                    </li>
                                    <li :class="{'active': $route.name == 'employee-notes'}">
                                        <router-link :to="routeToNotes"><span>NOTES</span></router-link>
                                    </li>


                                </ul>
                            </div>
                        </div>
                        <div v-if="workauthDropdown" class="profile-rightinfo_header">
                            <div class="header_tabs" :class="{'consultant_header_tabs' : true}">
                                <ul id="childNode1">
                                    <li v-if="isEadVisible" :class="{'active': $route.name == 'employee-ead'}">
                                        <router-link :to="routeToEad" :class="{'router-link-exact-active router-link-active':$route.name == 'employee-ead'}">
                                            <span>EAD/USC <i v-if="isEADMissingDocIconShow" class="fa fa-exclamation-circle" aria-hidden="true" style="color: red;"></i></span>
                                        </router-link>
                                    </li>
                                    <li v-if="isEadVisible"  :class="{'active': $route.name == 'employee-gc'}">
                                        <router-link :to="routeToGC" :class="{'router-link-exact-active router-link-active':$route.name == 'employee-gc'}">
                                            <span>GC <i v-if="isGCMissingDocIconShow" class="fa fa-exclamation-circle" aria-hidden="true" style="color: red;"></i></span>
                                        </router-link>
                                    </li>
                                    <li v-if="isH1bVisible" :class="{'active': $route.name == 'employee-h1b'}">
                                        <router-link :to="routeToH1b" ><span>H-1B</span></router-link>
                                    </li>
                                    <li :class="{'active': $route.name == 'employee-L1visa'}">
                                        <router-link :to="routeToL1Visa" :class="{'router-link-exact-active router-link-active':$route.name == 'employee-L1visa'}">
                                            <span>L-1 VISA <i v-if="isL1MissingDocIconShow" class="fa fa-exclamation-circle" aria-hidden="true" style="color: red;"></i></span>
                                        </router-link>
                                    </li>
                                    <li :class="{'active': $route.name == 'employee-E3Visa'}">
                                        <router-link :to="routeToE3Visa">
                                            <span>E-3 VISA <i v-if="isE3MissingDocIconShow" class="fa fa-exclamation-circle" aria-hidden="true" style="color: red;"></i></span>
                                        </router-link>
                                    </li>
                                    <li :class="{'active': $route.name == 'employee-TNVisa'}">
                                        <router-link :to="routeToTNVisa">
                                            <span>TN VISA <i v-if="isTNMissingDocIconShow" class="fa fa-exclamation-circle" aria-hidden="true" style="color: red;"></i></span>
                                        </router-link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div v-if="FormsDropdown" class="profile-rightinfo_header">
                            <div class="header_tabs" :class="{'consultant_header_tabs' :true}">
                                <ul id="childNode1">
                                    <li  :class="{'active': $route.name == 'employee-form-i983'}">
                                        <router-link :to="routeToI983" :class="{'router-link-exact-active router-link-active':$route.name == 'employee-form-i539'}">
                                            <span>FORM I-983 </span>
                                        </router-link>
                                    </li>
                                    <li  :class="{'active': $route.name == 'employee-form-i539'}">
                                        <router-link :to="routeToI539" :class="{'router-link-exact-active router-link-active':$route.name == 'employee-form-i539'}">
                                            <span>FORM I-539</span>
                                        </router-link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                         <div v-if="!workauthDropdown"  v-bind:class="[isDisplay ? 'display-block' : 'display-none']" style="overflow: auto;" id="childNode">
                           <ul >
                                <li v-if="isEadVisible" :class="{'active': $route.name == 'employee-ead'}">
                                        <router-link :to="routeToEad" :class="{'router-link-exact-active router-link-active':$route.name == 'employee-ead'}">
                                            <span>EAD/USC <i v-if="isEADMissingDocIconShow" class="fa fa-exclamation-circle" aria-hidden="true" style="color: red;"></i></span>
                                        </router-link>
                                    </li>
                                    <li v-if="(isEadVisible)" :class="{'active': $route.name == 'employee-gc'}">
                                        <router-link :to="routeToGC" :class="{'router-link-exact-active router-link-active':$route.name == 'employee-gc'}">
                                            <span>GC <i v-if="isGCMissingDocIconShow" class="fa fa-exclamation-circle" aria-hidden="true" style="color: red;"></i></span>
                                        </router-link>
                                    </li>
                                    <li v-if="isH1bVisible" :class="{'active': $route.name == 'employee-h1b'}">
                                        <router-link :to="routeToH1b" ><span>H-1B <i v-if="isH1BMissingDocIconShow" class="fa fa-exclamation-circle" aria-hidden="true" style="color: red;"></i></span></router-link>
                                    </li>
                                <li :class="{'active': $route.name == 'employee-L1visa'}">
                                <router-link :to="routeToL1Visa" :class="{'router-link-exact-active router-link-active':$route.name == 'employee-L1visa'}">
                                    <span>L-1 VISA <i v-if="isL1MissingDocIconShow" class="fa fa-exclamation-circle" aria-hidden="true" style="color: red;"></i></span>
                                </router-link>
                                </li>
                                <li :class="{'active': $route.name == 'employee-E3Visa'}">
                                <router-link :to="routeToE3Visa" :class="{'router-link-exact-active router-link-active':$route.name == 'employee-E3Visa'}">
                                    <span>E3 VISA <i v-if="isE3MissingDocIconShow" class="fa fa-exclamation-circle" aria-hidden="true" style="color: red;"></i></span>
                                </router-link>
                                </li>
                                <li :class="{'active': $route.name == 'employee-TNVisa'}">
                                <router-link :to="routeToTNVisa">
                                    <span>TN VISA <i v-if="isTNMissingDocIconShow" class="fa fa-exclamation-circle" aria-hidden="true" style="color: red;"></i></span>
                                </router-link>
                                </li>
                            </ul>
                        </div>
                        <div v-if="!FormsDropdown" v-bind:class="[isFormsDisplay ? 'display-block' : 'display-none']" style="overflow: auto;" id="childNode">
                            <ul >
                                <li  :class="{'active': $route.name == 'employee-form-i983'}">
                                        <router-link :to="routeToI983" :class="{'router-link-exact-active router-link-active':$route.name == 'employee-form-i983'}">
                                            <span>FORM I-983 </span>
                                        </router-link>
                                    </li>
                                    <li  :class="{'active': $route.name == 'employee-form-i539'}">
                                        <router-link :to="routeToI539" :class="{'router-link-exact-active router-link-active':$route.name == 'employee-form-i539'}">
                                            <span>FORM I-539</span>
                                        </router-link>
                                    </li>
                            </ul>
                        </div>
                        <div v-if="workauthDropdown" style="height: calc(100% - 96px); overflow: auto;">
                            <router-view></router-view>
                        </div>
                        <div v-else-if="FormsDropdown" style="height: calc(100% - 96px); overflow: auto;" >
                            <router-view ></router-view>
                        </div>
                        <div v-else style="height: calc(100% - 48px); overflow: auto;">
                            <!--:id="cssIDforChildViews"-->
                            <router-view></router-view> <!--:id="id" :is-on-blick="isOnBlick" :consultant-details="consultantDetails"-->
                        </div>
                    </div>
                    <div>
                <Work-Auth-History :openModal.sync="viewWorkAuthPopupVal" :consultantObj="consultantObj" :empStartDate="empData.EmpStartDate" @openWorkAuthComposeMailPopup="openWorkAuthComposeMailPopup(...arguments)"></Work-Auth-History>
                <Work-Auth-Compose-Mail :openModal.sync="isShowComposeMail" :empName="empData.Name" :attachmentLink="link" @composeMail="OpenWorkauth()"></Work-Auth-Compose-Mail>
            </div>
                </template>


                <!--right section of the profile end-->



            </ob-layout>

        <!-- Layout for ESS Profile View -->

        </div>

    </div>
 </base-layout>
</template>

<script>
import c from '@/components/Core/constants.js'
import jquery from "jquery";
import utils from "@/components/Core/utils.js";
import WorkAuthHistory from '@/components/Profile/WorkAuthorizationHistoryPopup.vue'
import WorkAuthComposeMail from '@/components/Profile/ShareWorkAuthHistory.vue'
import moment from "moment";
export default {
  data() {
    return {
      // router links
      props: ["id", "type","isShowWorkAuthHistoryDoc"],
      "Sendmailpopup": {
          "isModalOpened": false
      },
      link:{},
      showAttention:false,
      viewWorkAuthPopupVal:false,
      isShowComposeMail: false,
      consultantObj:{},
      routeToEmployee: {
        name: "employee-details",
        query: this.$route.query
      },

      routeToProject: {
        name: "employee-projects",
        query: this.$route.query
      },

      routeToResume: {
        name: "employee-resume",
        query: this.$route.query
      },

      routeToNotes: {
        name: "employee-notes",
        query: this.$route.query
      },

      routeToH1b: {
        name: "employee-h1b",
        query: this.$route.query
      },

      routeToGC: {
        name: 'employee-gc',
        query: this.$route.query
      },
       routeToL1Visa:{
                name: 'employee-L1visa',
                query: this.$route.query
            },
       routeToE3Visa:{
                name: 'employee-E3Visa',
                query: this.$route.query
            },
       routeToTNVisa:{
                name: 'employee-TNVisa',
                query: this.$route.query
            },

      routeToI9: {
        name: "employee-i9",
        query: this.$route.query
      },
      routeToI983: {
        name: "employee-form-i983",
        query: this.$route.query
      },
      routeToI539: {
        name: "employee-form-i539",
        query: this.$route.query
      },

      routeToEad: {
        name: "employee-ead",
        query: this.$route.query
      },
      complianceAlertsC2C: '',
      alertTypeC2C:'',
      empData: '',
      alertsData:'',
      alertsLength: '',
      leftLoader: true,
      alertLoader: true,
      empProfile:'',
      H1BData:false,
      EADData:false,
      mailShow:true,
      empInfo:{
              FirstName:'',
              MiddleName:'',
              LastName:'',
              Designation:'',
              EmailId:'',
              PhoneNo:"",
              Gender:'',
              DOB:"",
              WorkAuthorizationType:'',
              Department:'',
              CurrentProjectStartDate:'',
              Address:'',
              CurrentProjectStartDateString:'',
              // BillRate:'',
              // MaxWageRate:'',
              MinWageRate:'',
              YearsOfEmployement:"",
              HireType:''

          },
      isDisplay:false,
      isFormsDisplay:false,
      isMissingDocIconShow: false,
      isEADMissingDocIconShow: false,
      isGCMissingDocIconShow: false,
      isH1BMissingDocIconShow: false,
      isL1MissingDocIconShow: false,
      isTNMissingDocIconShow: false,
      isE3MissingDocIconShow: false,
    };
  },
  components:{
      "Work-Auth-History":  WorkAuthHistory,
      "Work-Auth-Compose-Mail" :WorkAuthComposeMail
  },
  computed: {
    profilePicture() {
     if (
       this.empProfile.ProfilePicLink != "" &&
       this.empProfile.ProfilePicLink != null
      )
        return this.empProfile.ProfilePicLink;
      else return `${c.CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/noimage.svg`;
    },
    leftSectionContentHeight() {
      // left section height
      return "100%";
    },

    consultantDetails: {
      get() {
        return this.$store.getters.getConsultantDetails;
      },
      set(value) {
        this.$store.commit("updateConsultantDetails", value);
      }
    },


    empDetails(){

        return this.$store.getters.getEmpDetails
    },

    empStartDate(){
        return this.empDetails.EmployementStartDateString
    },

   phoneNumber(){
            return this.empDetails.PhoneNo
    },
    isEadVisible() {
            if (this.isHRManager)
                return true;
            else
                return false;
        },

    isEadVisible() {
                return true;
    },
    isH1bVisible(){
                return true;
    },
   // isI983Visible() {
      // if (
      //       this.empData.WorkPermit == "CPT" ||
      //       this.empData.WorkPermit == "STEM OPT" ||
      //       this.empData.WorkPermit == "OPT EAD"
      //    //   || this.empData.WorkPermit == "EAD OTHERS"
      // ) {
      //   return true;
      // } else {
      //     return false;
      // }
      //return true;
    //},
    show_WorkAUTH(){
            if(((this.isEadVisible) && (this.$route.query.tax == 'W2')))
            {
                return true
            }
            else{
                return false
            }
        },
         workauthDropdown(){
            if(this.isFormsDisplay==true){
                this.isDisplay = false;
                return false 
            }
            else if(this.$route.name == 'employee-ead' || this.$route.name == 'employee-gc' || this.$route.name == 'employee-h1b'
                    || this.$route.name == 'employee-L1visa' || this.$route.name == 'employee-E3Visa' || this.$route.name == 'employee-TNVisa'){
                this.isDisplay = false;
                this.isMissingDocIconShow = false
                return true
            }
            else if(this.isDisplay){
                return false
            }
            else{
                this.isDisplay = false;
                return false
            }
        },
        FormsDropdown(){
            if(this.isDisplay==true){
                this.isFormsDisplay = false;
                return false 
            }
            else if(this.$route.name == 'employee-form-i983' ){
                this.isFormsDisplay = false;
                return true
            }
            else if(this.$route.name=='employee-form-i539'){
               this.isFormsDisplay = false;
                return true 
            }
            else if(this.isFormsDisplay){
                return false
            }
            else{
                this.isFormsDisplay = false;
                return false
            }
        },
         WorkAUTH(){
          if(this.$route.name == 'employee-details' || this.$route.name == 'employee-projects' || this.$route.name == 'employee-i9' ||
            this.$route.name == 'employee-form-i983' ||this.$route.name == 'employee-form-i539' || this.$route.name == 'employee-resume' || this.$route.name == 'employee-notes'){
                return false
            }
            else{
                return true
            }
        },
        Forms(){
            if(this.$route.name == 'employee-form-i983'||this.$route.name == 'employee-form-i539'){
                return true
            }
            else{
                return false
            }
        },

  },

    created(){
        this.getEmpDetails()
        this.getH1BDetails()
        this.getEADDetails()
        //this.getProfile()
        this.docAlerts()
        //this.isESSObj()
        events.listen('leftSection',()=>{
            this.getEmpDetails()
        })
       events.listen('profileUpdate',()=>{
        this.getProfile()
       })
       events.listen('profileRemoved',()=>{
        this.getProfile()
      })
      this.consultantDetailsObj();

    },
    methods:{
      getDescription(desc)
    {
       return desc.replace(loggedInUserObj.name + "'s", "Your");
    },
      OpenWorkauth(){
            this.isShowComposeMail = false
            setTimeout(() => {
            this.viewWorkAuthPopupVal = true
            }, 500)
        },
        mailCopy(){
            var mail = this.empData.Email;
            this.mailShow = false;
            this.copyMailToClipboard(mail);
        },
        copyMailToClipboard(val){
          var create = document.createElement("input");
          document.body.appendChild(create);
          create.setAttribute('value',val);
          create.select();
          document.execCommand('copy');
          document.body.removeChild(create);
          setTimeout(()=>{
            this.mailShow = true;
          },2000)

        },
        showWorkAuthHistory(){
            this.$refs.popover.doClose()
            this.viewWorkAuthPopupVal = true
        },
        openWorkAuthComposeMailPopup(args) {
            this.viewWorkAuthPopupVal = false
            this.isShowComposeMail = true
            this.link = args
        },
        consultantDetailsObj(){
            this.consultantObj = {
            "EmployeeId":loggedInUserObj.empId,
            "ConsultantId":this.$route.params.id,
            "TaxTerms" : this.$route.query.tax,
            }
        },
        getEmpDetails(){
             this.leftLoader = true
                ajax.get(`/Employee/${loggedInUserObj.empId}/BasicInfo`, {}, (res) => {
                    if(res.data.State == true){
                            this.empData = res.data.Employee
                            console.log("this.empData",this.empData)
                            this.consultantDetails = res.data.Employee
                            this.empProfile = res.data.Employee
                            this.leftLoader = false

                    }else{
                            this.leftLoader = false
                            this.ESSEnableDisable(res)
                    }
                })
        },
        getH1BDetails(){
            if(loggedInUserObj.HireType =='W2'){
                ajax.get(`H1B/GetESSH1BDetails?consultantId=${loggedInUserObj.consultantId}&orgId=${loggedInUserObj.orgId}`,{},res => {
                    if(res.data.State == true){
                        if(res.data.ESSH1BDetailsViewModel != '' && res.data.ESSH1BDetailsViewModel != null){
                        this.H1BData = true
                        }
                        else{
                            this.ESSEnableDisable(res)
                            this.H1BData = false
                        }

                    }
                })
            }
        },
        getEADDetails(){
            if(loggedInUserObj.HireType == 'W2'){
                ajax.get(`Employee/${loggedInUserObj.consultantId}/GetEADDocuments?orgId=${this.loggedInUserObj.orgId}`, {}, (res) => {
                    if (res.data.State == true) {
                        if(res.data.EADDocuments != '' && res.data.EADDocuments != null){
                            this.EADData = true
                        }
                        else{
                            this.ESSEnableDisable(res)
                            this.EADData = false
                        }

                    }


                })
            }
        },
        docAlerts(){
           // if(this.loggedInUserObj.HireType == 'W2'){
                ajax.get(`Employee/${loggedInUserObj.consultantId}/DocumentAlerts?orgId=${loggedInUserObj.orgId}`,{},(res) => {
                    if(res.data.State == true){
                        this.alertsData = res.data.DocumentAlerts
                        this.alertsLength = res.data.DocumentAlerts.length
                        this.alertLoader = false
                    }else{
                        this.alertLoader = false
                        this.ESSEnableDisable(res)
                    }
                })
        //    }
            // else{
            //     ajax.get(`/Employee/${loggedInUserObj.empId}/CurrentWorkAuthExpiryAlert`, {}, res => {
            //         if(res.data.State == true){
            //             var description = res.data.CurrentWorkAuthExpireAlert.Description;
            //             var alertType = res.data.CurrentWorkAuthExpireAlert.AlertType;
            //                 if ( description != null  && description != '') {
            //                 this.complianceAlertsC2C = description
            //                 this.alertTypeC2C = alertType
            //                 } else {
            //                 this.leftLoader = false;
            //                 }
            //                 this.leftLoader = false;
            //         }
            //         else{
            //             this.ESSEnableDisable(res)
            //         }
            //     });
            // }

        },
        getProfile(){
            ajax.get(`/Employee/${loggedInUserObj.empId}/BasicInfo`, {}, (res) => {
                    if(res.data.State == true){
                        this.empProfile = res.data.Employee
                    }
                    else{
                       this.ESSEnableDisable(res)
                    }
            })
        },

       WorkAuthMethod(){
            if(this.isDisplay)
            {
               if(this.isEADMissingDocIconShow || this.isGCMissingDocIconShow || this.isH1BMissingDocIconShow ||
                   this.isL1MissingDocIconShow || this.isTNMissingDocIconShow || this.isE3MissingDocIconShow){
                         if(!(this.$route.name == 'employee-ead' || this.$route.name == 'employee-gc' || this.$route.name == 'employee-h1b' ||
                             this.$route.name == 'employee-L1visa' || this.$route.name == 'employee-E3Visa' || this.$route.name == 'employee-TNVisa'))
                                 this.isMissingDocIconShow = true
                 }

                this.isDisplay = false;
            }
            else {
                this.isMissingDocIconShow = false
                this.isDisplay = true;
            }
        },
        FormsMethod(){
        if(this.isFormsDisplay){
         this.isFormsDisplay = false;
        }else{
            this.isFormsDisplay = true;
        }
    },
    },
    watch:{

    }
};
</script>

<style lang="scss" scoped>
@import "~styles/framework/vue-utils";
   .profile-info_rightinfo{
       position:relative;
    }
    .profile-info_rightinfo{
        .profile-rightinfo_header{
            .header_tabs{
                ul{
                    margin-left:0px !important;
                    li{
                        margin-left:0px !important;
                        span{
                            padding: 15px 0px 13px 0px !important;
                            margin: 0 7px 0 7px !important;
                        }
                    }
                }
            }
        }
    }
    // switch for ESS status
    .switch {
    position: relative;
    display: inline-block;
    width: 52px;
    height: 30px;
    }

  .switch input {
    display: none;
    }
    .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    -webkit-transition: 0.4s;
    transition: 0.4s;
    }

   .slider:before {
    position: absolute;
    content: "";
    height: 23px;
    width: 23px;
    left: 1px!important;
    bottom: 4px;
    background-color: white;
    -webkit-transition: 0.4s;
    transition: 0.4s;
    }

    input:checked + .slider {
    background-color: #52d76a;
    }

    input:focus + .slider {
    box-shadow: 0 0 1px #52d76a;
    }

    input:checked + .slider:before {
    -webkit-transform: translateX(26px);
    -ms-transform: translateX(26px);
    transform: translateX(26px);
    }

    /* Rounded sliders */
    .slider.round {
    border-radius: 34px;
    margin-right: 0;
    }

    .slider.round:before {
    border-radius: 50%;
    }
#childNode li, #childNode1 li{
    padding-right:10px;
}
#childNode li a span{
    padding-right:10px;
    color: #9FA2A6;
}
#childNode li:hover a span{
    color:#143361
}
#childNode li{
    display:inline;
}
#childNode ul{
   padding: 15px 0 4px 20px;
}
#childNode{
    z-index: 9999;
    position: absolute;
    width: 100%;
    background: rgb(255, 255, 255);
    display: none;
    //box-shadow: 0 0 4px rgb(180, 175, 175);
    -webkit-box-shadow: 0 8px 10px -1px rgb(156, 152, 152);
	-moz-box-shadow: 0 8px 10px -1px rgb(156, 152, 152);
	box-shadow: 0 8px 10px -1px rgb(156, 152, 152);
}
#childNode.display-block{
display:block
}
#childNode.display-none{
display:none
}
.alertpara{
    text-align: center;
    margin-bottom: 15px;
    padding-left: 20px;
    padding-right: 20px;
}
</style>

<style lang="scss">
@import "~styles/framework/vue-utils";
.box-shadow > div > div > div + div > div{
  box-shadow:none;
}
.box-shadow > div > div > div + div > div > div >div + div {
  box-shadow: #ddd 0px 0px 4px;
}
.document-alerts {
  margin: 0;
  .document-alert-title {
    font-size: 12px;
    font-weight: 600;
    margin-left: 10px;
  }

  .document-alert-info {
    font-size: 10px;
    margin: 10px 0 0 10px;
  }

  .document-alert-img {
    width: 15px;
    margin-bottom: 5px;
  }
}

.extend-project {
.Extend-Project-btn {
    //display: inline-block;
    color: #4a90e2;
    width: 50%;
    float: left;
    padding: 15px 5px;
    text-align: center;
    &:first-child {
      border-right: 1px solid #c2c2c2;
    }
  //  padding: 5px 5px;
}
}
.extend-project{
  .Extend-Project-btn{
    display: inline-block;
    color: #4a90e2;
    width: 50%;
    float: left;
    //padding: 10px 5px;
    text-align: center;
    padding: 15px 5px;
    // &:first-child{
    //   border-right:1px solid #c2c2c2;
    // }

  }
}
.update-offer-btn{
  color:#4a90e2;
  display:inline-block;
  padding: 15px 152px;
}
.vue-my-database-page {

 @import "~styles/pages/vue/my-database/components/profile";
}
.header_tabs {
  // width: calc(100% - 160px);
  width: 100%;
}
.consultant_header_tabs{
  // width: calc(100% - 160px) !important;
  width: 100%;

}
.show-groups-loader {
  position: absolute;
  background: rgba(204, 204, 204, 0.3);
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
}
.common_info{
  .common_info-cta{
    color:#4a90e2;
    padding:0px 5px 5px 5px;
    font-size:12px;
  }
}
.profile-submit-to-client{
  padding-bottom:10px;
}
.collapase-details-holder {
  margin:  10px 0;
  /*padding-left: 25px;*/
  h3 {
    font-size: 13px;
    color: #707070;
  }
  span {
    font-size: 13px;
    font-weight:600;
    color: #4a4a4a;
  }
}
.panel-title {
  font-weight: 600;
  color: #143361;
  font-size: 13px;
}
.alert-val {
  padding: 3px 6px;
  border-radius: 3px;
  background: #f41111;
  margin-left: 3px;
  color: #fff;
  font-size: 10px;
}
.m-0 {
  margin:0;
}
.text_Namefol-email{
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display:inline-block;
  width:135px;
}

.consultant-edit-profile-btn {
  color: #fff;
  text-transform: uppercase;
  font-size: 16px;
  display: block;
  height: 50px;
  padding: 10px;
  line-height: 30px;
  text-align: center;
  background: $ob-brand-primary;
  position: absolute;
  width: 100%;
  bottom: 0;
  &:hover,
  &:active,
  &:focus {
  color: #fff;
  }
  }

  .fa-play-circle-o:before {
  content: "\f01d";
  position: absolute;
  font-size: 40px;
  left: 8%;
  top: 28%;
  color: #fff;
  }
  .profile_img_name {
  min-height: 0px !important;
  border-bottom: 0px !important;
}

.profile_img_name label img {
  width: 100%;
  vertical-align: top;
}
.profile-name-heading {
  width: 150px !important;
}

  .profile_img_name:after, .profile_img_name:before {
  position:absolute;
  opacity:0;
  transition: all 0.5s;
  -webkit-transition: all 0.5s;
  }
  .profile_img_name:after {
  content: "\A";
  width: 40px;
  height:80px;
  //top:10px;
  left:10px;
  border-radius: 5px;
  //background:rgba(0,0,0,0.6);
  }
  .profile_img_name:before {
  width:100%;
  color:#fff;
  z-index:1;
  bottom:0;
  padding:4px 10px;
  text-align:center;
  background:red;
  box-sizing:border-box;
  -moz-box-sizing:border-box;
  }
  .profile_img_name:after, .profile_img_name:before {
  opacity:0.5;
  }
  .profile_img_name label {
  padding: 10px 0 0 15px !important;
}
.fa-play-circle-o:before {
  z-index: 1;
  cursor:pointer;
  }
  .image_opacity:after, .image_opacity:before {
  opacity: 0;
  }
  .icon-share {
  .share-icons{
  border-bottom: 0 !important;
  float: right;
  ul li {
  padding: 0 0 0 9px !important;
  img {
  height: 18px !important;
  }
  }
  }
  }
  .display-check{
  display:block;
  width: auto !important;
  }
  @media only screen and (max-width: 1210px) {
  .fa-play-circle-o:before {
  content: "\F01D";
  position: absolute;
  font-size: 40px;
  left: 8%;
  top: 17%;
  color: #fff;
  }
  }
  .update-offer-bottom{
  border-top:1px solid #c2c2c2;
  }
  .designation-name {
  width: 150px !important;
}
  .role.designation-name {
  font-size: 12px;
  }

  .load-more-link {
  position: relative;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 5%;
  display: block;
  text-align: center;

  }

  .expiring-msg {
  background: #f76565;
  margin: 0px;
  text-align: center;
  font-weight: 600;
  padding: 16px;
  }
  .expiring-msg p, .expired-msg p {
  color: #ffffff;
  }

  span.Profile_rating .fa {
  font-size: 11px;
  }
 .pop-para {
  cursor:pointer;
   padding:3px 0;
   text-align: left;
  }
  .pop-para:hover {
  color: #337ab7;
  }
  .sidenav {
  height: 82.5%;
  top: 11%;
  width: 22%;
  position: fixed;
  z-index: 1003;
  right: 0;
  background-color: #fff;
  transition: 0.5s;
  overflow-x: hidden;
  box-shadow: 0px 2px 7px 0px #999;
  border-radius: 10px;
  border-bottom:1px solid #DFDFDF;
  }

  .side-nav-items div:hover{
  background:unset;
  }
  .folder-header-heading {
  font-weight: bold;
  color: #143361;
  }
  .colourApply {
  float: right;
  padding: 15px;
  color: #4a90e2;
  cursor: pointer;
  line-height: 16px;
  text-decoration: underline;
  }
  .collapse-header {
  // background: unset !important;
  background: #eff6ff;
    padding: 10px 15px;
    border-bottom: 1px solid #e5e5e5;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    display: table;
    width: 100%;

  }
  .collapse-header h3 {
  font-size: 12px;
  }

  .sidenav a {
  padding: 0px 8px 8px 32px;
  text-decoration: none;
  font-size: 11px;
  color: #75aae9;
  display: block;
  transition: 0.3s;


  }

  .sidenav .closebtn {
  font-size: 20px;
  display: inline-block;
  padding-left: 62%;
  color: black;

  }
  .header-items {
  font-size: 13px;
  display: inline-block;
  padding-left: 10PX;
  color: #4a90e2;
  font-weight: 600;

  }
  .panel-title {
  color: #143361;
  font-weight: 800;
  }
  .sideNavHeader {
  padding-top:7px;
  border-bottom: 1px solid #DFDFDF;
  padding-bottom:10px;
  }


.profile_img_name.image_opacity.cancel-endEmployee{
 border-bottom:none;
}
.contact-details{
border-bottom: 1px solid #ddd;
}
#alert {
    color: #f39e1c;
    padding-top: 0;
    font-size: 25px;
    font-weight: 500;
    height: 50px;
    transform: scale(.97, 1);
}

#para {
    color: #143361;
    font-size: 13px;
    font-weight: 600;
    margin: 0px;
}

#italic {
    font-style: italic;
    color: #707070;
    margin:0px;
}
.button{
    margin-right:20px;
}

  </style>
  <style lang="scss" scoped>
  .alert-val {
  padding: 3px 6px;
  border-radius: 3px;
  background: #f41111;
  margin-left: 3px;
  color: #fff;
  font-size: 10px;
}
 .soc-datas {
  font-size: 12px;
  color: #143361;
  font-weight: 600;
  padding: 4px 0px;
}
.margin-0 {
  margin: 0px;
}
.compliance-alert-img{
    width: 15px;
    margin-bottom: 5px;
}
.compliance-alert-title{
    font-size: 12px;
    font-weight: 600;
    margin-left: 10px;
}
.pop-para {
  cursor:pointer;
   padding:3px 0;
   text-align: left;
  }
  .pop-para:hover {
  color: #337ab7;
  }
  .alert-time {
        padding: 5px 0px;
        p{
        padding-left: 10px;
        display: inline-block;
        i{
        font-size: 13px;
        color: #777;
        padding-right: 5px;
      }
     }
    }
</style>



// WEBPACK FOOTER //
// src/components/ESSProfile/EmployeeProfile.vue